import { ConvertObjectCamelToSnakeCase } from "@/app/infrastructures/misc/Utils";
import {
  PayloadCreateBagging,
  PayloadUpdateReadyToCargo
} from "@/domain/entities/Bagging";
import { QueryParamsEntities } from "@/domain/entities/MainApp";
import {
  BaggingDisputeSummaryRequestInterface,
  BaggingToReadyToCargoRequestInterface,
  ChangeBaggingRequestInterface,
  UpdateBaggingInterface
} from "../contracts/BaggingRequest";
import { getHubData } from "@/app/infrastructures/misc/Cookies";
import { FlagsPermissionBagging } from "@/feature-flags/flags-permission-bagging";

/* eslint-disable @typescript-eslint/camelcase */
export class CreateApiRequest implements ChangeBaggingRequestInterface {
  payload: PayloadCreateBagging = new PayloadCreateBagging();
  constructor(fields?: Partial<PayloadCreateBagging>) {
    Object.assign(this.payload, fields);
  }
  public toJSON(): string {
    const dimensionDivider = FlagsPermissionBagging.config_dimension_divider.getValue();
    return JSON.stringify(
      ConvertObjectCamelToSnakeCase({
        ...this.payload,
        bagDimensionDivider: dimensionDivider
      })
    );
  }
}

export class UpdateBaggingRequest implements UpdateBaggingInterface {
  private bagId: number;
  private customGrossWeight: number;
  private customLength: number;
  private customWidth: number;
  private customHeight: number;
  private bagSttNo: Array<any>;
  private partnerId?: number;
  private totalBagChargeableWeight?: number;
  private totalSttDgCount?: number;
  private totalPieceSttDgCount?: number;
  private totalSttGrossWeight?: number;
  private totalSttVolumeWeight?: number;
  private totalSttChargeableWeight?: number;
  private isUseNewCalculation?: boolean;
  private photoProof?: string;
  private customVolumeWeight?: number;

  constructor(
    bagId: number,
    customGrossWeight: number,
    customLength: number,
    customWidth: number,
    customHeight: number,
    bagSttNo: Array<any>,
    partnerId?: number,
    totalBagChargeableWeight?: number,
    totalSttDgCount?: number,
    totalPieceSttDgCount?: number,
    totalSttGrossWeight?: number,
    totalSttVolumeWeight?: number,
    totalSttChargeableWeight?: number,
    isUseNewCalculation?: boolean,
    photoProof?: string,
    customVolumeWeight?: number
  ) {
    this.bagId = bagId;
    this.customGrossWeight = customGrossWeight;
    this.customLength = customLength;
    this.customWidth = customWidth;
    this.partnerId = partnerId;
    (this.customHeight = customHeight), (this.bagSttNo = bagSttNo);
    this.totalBagChargeableWeight = totalBagChargeableWeight;
    this.totalSttDgCount = totalSttDgCount;
    this.totalPieceSttDgCount = totalPieceSttDgCount;
    this.totalSttGrossWeight = totalSttGrossWeight;
    this.totalSttVolumeWeight = totalSttVolumeWeight;
    this.totalSttChargeableWeight = totalSttChargeableWeight;
    this.isUseNewCalculation = isUseNewCalculation;
    this.photoProof = photoProof;
    this.customVolumeWeight = customVolumeWeight;
  }
  public toJSON(): string {
    const dimensionDivider = FlagsPermissionBagging.config_dimension_divider.getValue();
    return JSON.stringify({
      bag_id: this.bagId,
      custom_gross_weight: this.customGrossWeight,
      custom_length: this.customLength,
      custom_width: this.customWidth,
      custom_height: this.customHeight,
      bag_stt_no: this.bagSttNo,
      partner_id: this.partnerId,
      hub_id: getHubData()?.hubId,
      hub_name: getHubData()?.hubName,
      hub_origin_city: getHubData()?.originCity,
      hub_district_code: getHubData()?.hubDistrictCode,
      total_bag_chargeable_weight: this.totalBagChargeableWeight,
      total_stt_dg_count: this.totalSttDgCount,
      total_piece_stt_dg_count: this.totalPieceSttDgCount,
      total_stt_gross_weight: this.totalSttGrossWeight,
      total_stt_volume_weight: this.totalSttVolumeWeight,
      total_stt_chargeable_weight: this.totalSttChargeableWeight,
      is_use_new_calculation: this.isUseNewCalculation,
      photo_proof: this.photoProof,
      custom_volume_weight: this.customVolumeWeight,
      bag_dimension_divider: dimensionDivider
    });
  }
}

export class BaggingListRequest {
  page = 1;
  limit = 10;
  startDate = "";
  endDate = "";
  search = "";
  partnerId = 0;
  hubIds = 0;
  countryCode = "";
  constructor(fields?: Partial<BaggingListRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class BaggingToReadyToCargoRequest
  implements BaggingToReadyToCargoRequestInterface {
  payload: PayloadUpdateReadyToCargo = new PayloadUpdateReadyToCargo();
  constructor(fields?: Partial<PayloadUpdateReadyToCargo>) {
    Object.assign(this.payload, fields);
  }
  public toJSON(): string {
    return JSON.stringify(
      ConvertObjectCamelToSnakeCase({
        ...this.payload,
        hubId: getHubData()?.hubId || 0
      })
    );
  }
}

export class BaggingDisputeSummaryRequest {
  hubIds = "";
  startDate = "";
  endDate = "";
  constructor(fields?: Partial<BaggingDisputeSummaryRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class DownloadBaggingDisputeSummaryRequest
  implements BaggingDisputeSummaryRequestInterface {
  hubIds = "";
  startDate = "";
  endDate = "";
  constructor(fields?: Partial<DownloadBaggingDisputeSummaryRequest>) {
    Object.assign(this, fields);
  }

  public toJSON(): string {
    return JSON.stringify(
      ConvertObjectCamelToSnakeCase({
        hubIds: this.hubIds,
        startDate: this.startDate,
        endDate: this.endDate
      })
    );
  }
}
